import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import PagePreview from '../entity/PagePreview';

export const startFetchingPagePreviews = () =>
  produce((draft: Draft<State>) => {
    draft.pagePreviews.fetching = draft.pagePreviews.fetching + 1;
  });

export const setPagePreviews = (pagePreviews: PagePreview[]) =>
  produce((draft: Draft<State>) => {
    draft.pagePreviews.data = pagePreviews;
  });

export const finishFetchingPagePreviews = () =>
  produce((draft: Draft<State>) => {
    draft.pagePreviews.fetching = draft.pagePreviews.fetching - 1;
  });

export const disposePagePreviews = () =>
  produce((draft: Draft<State>) => {
    draft.pagePreviews.data = initialState.pagePreviews.data;
    draft.pagePreviews.fetching = initialState.pagePreviews.fetching;
  });
